export const MAX_ASSOCIATIONS = 1;
